import Vue from 'vue'
import Router from 'vue-router'

const Home = () => import(/* webpackChunkName: "home" */ '@/components/home/Home')
const AnchorPage = () => import(/* webpackChunkName: "goal" */ '@/components/goals/AnchorPage')
const GoalContentPage = () =>
  import(/* webpackChunkName: "goal" */ '@/components/goals/GoalContentPage')
const SavedGoalContentPage = () =>
  import(/* webpackChunkName: "goal" */ '@/components/goals/SavedGoalContentPage')
const SharedGoalContentPage = () =>
  import(/* webpackChunkName: "savedgoal" */ '@/components/goals/SharedGoalContentPage')
const StrategyDetailPage = () =>
  import(/* webpackChunkName: "strategy" */ '@/components/strategies/StrategyDetailPage')
const SavedStrategyPage = () =>
  import(/* webpackChunkName: "savedstrategy" */ '@/components/strategies/SavedStrategyPage')
const SharedStrategyDetailPage = () =>
  import(/* webpackChunkName: "strategy" */ '@/components/strategies/SharedStrategyDetailPage')
const FavoritesPage = () =>
  import(/* webpackChunkName: "favorites" */ '@/components/favorites/FavoritesPage')

const PresentLevels = () =>
  import(/* webpackChunkName: "presentlevels" */ '@/components/PresentLevels')
const PresentlevelsWizardFilters = () =>
  import(/* webpackChunkName: "presentlevels" */ '@/components/presentlevels/PresentLevelsWizardFilters')
const PresentlevelsResults = () =>
  import(/* webpackChunkName: "presentlevels" */ '@/components/presentlevels/PresentLevelsResults')
const PresentlevelsConclusion = () =>
  import(/* webpackChunkName: "presentlevels" */ '@/components/presentlevels/PresentLevelsConclusion')
const SharedPresentLevelsPage = () =>
  import(/* webpackChunkName: "presentlevels" */ '@/components/presentlevels/SharedPresentLevelsPage')
const PresentLevelsConclusionAssessments = () =>
  import(/* webpackChunkName: "presentlevels" */ '@/components/presentlevels/PresentLevelsConclusionAssessments')
const PresentlevelsConclusionGoalsStrategies = () =>
  import(/* webpackChunkName: "presentlevels" */ '@/components/presentlevels/PresentLevelsConclusionGoalsStrategies')
const PresentlevelsConclusionStatement = () =>
  import(/* webpackChunkName: "presentlevels" */ '@/components/presentlevels/PresentLevelsConclusionStatement')

const ImpactOfDisability = () => import(/* webpackChunkName: "presentlevels" */ '@/components/impact-of-disability/ImpactOfDisability')

const SavedAnchorPage = () =>
  import(/* webpackChunkName: "savedgoal" */ '@/components/goals/SavedAnchorPage')
const SharedAnchorPage = () =>
  import(/* webpackChunkName: "savedgoal"*/ '@/components/goals/SharedAnchorPage')

const BrowseGoalsWizard = () =>
  import(/* webpackChunkName: "browse" */ '@/components/search/BrowseGoalsWizard')
const BrowseGoalsWizardModal = () =>
  import(/* webpackChunkName: "browse" */ '@/components/search/BrowseGoalsWizardModal')
const BrowseGoalsPage = () =>
  import(/* webpackChunkName: "browse" */ '@/components/search/BrowseGoalsPage')
const GoalIndexPage = () =>
  import(/* webpackChunkName: "browse" */ '@/components/goalindex/GoalIndexPage')
const SearchPage = () =>
  import(/* webpackChunkName: "betasearch" */ '@/components/search/SearchPage')
const BrowseAssessments = () =>
  import(/* webpackChunkName: "browse" */ '@/components/search/assessments/BrowseAssessments.vue')
const AssessmentWizard = () =>
  import(/* webpackChunkName: "browse" */ '@/components/search/assessments/AssessmentWizard.vue')
const BrowsePresentLevelsPage = () =>
  import(/* webpackChunkName: "browse" */ '@/components/search/presentlevels/BrowsePresentLevelsPage')

const StrategyIndexPage = () =>
  import(/* webpackChunkName: "strategies" */ '@/components/strategies/udlindex/StrategyIndexPage')
const StrategyWizard = () =>
  import(/* webpackChunkName: "strategies" */ '@/components/strategies/StrategyWizard')
const BrowseStrategiesPage = () =>
  import(/* webpackChunkName: "strategies" */ '@/components/strategies/BrowseStrategiesPage')

const CollectionPage = () =>
  import(/* webpackChunkName: "curatedcollections" */ '@/curatedcollections/CollectionPage')

const EditAnchorAccessPointsPage = () =>
  import(/* webpackChunkName: "admin" */ '@/admin/EditAnchorAccessPoints')
const NewAnchorAccessPoints = () =>
  import(/* webpackChunkName: "admin" */ '@/admin/NewAnchorAccessPoints')

import { toolkitUrls, urlHelpers } from '@/links'
import { setTitle } from '@/util/title'
import { setOrAppendNoIndexMetaTag } from '@/util/noindex'
import store from '@/store'

Vue.use(Router)
var router = new Router({
  mode: 'history',

  // aww yeah: https://router.vuejs.org/en/advanced/scroll-behavior.html
  scrollBehavior(to, from, savedPosition) {
    let routesToPreserveScrolling = [
      'BrowseGoalsPage',
      'BrowseGoalsWizardModal',
      'StrategyWizard',
      'BrowseStrategiesPage',
      'BrowsePresentLevelsPage',
      'ImpactOfDisability'
    ]
    if (savedPosition) {
      return savedPosition
    } else if (
      routesToPreserveScrolling.indexOf(to.name) > -1 &&
      routesToPreserveScrolling.indexOf(from.name) > -1
    ) {
      return
    } else {
      return { x: 0, y: 0 }
    }
  },
  base: process.env.VUE_APP_ROUTER_BASE,
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
      meta: {
        title: 'Home',
        requiresAuth: true,
        noindex: true
      }
    },

    // Content Admin Pages
    {
      path: '/admin/anchor-page/new',
      name: 'NewAnchorAccessPoints',
      component: NewAnchorAccessPoints,
      meta: {
        title: 'New Anchor Page w/ Access Points',
        noindex: true,
        adminAccess: true
      }
    },
    {
      path: '/admin/edit/anchor-page/:uuid',
      name: 'EditAnchorAccessPoints',
      props: true,
      component: EditAnchorAccessPointsPage,
      meta: {
        title: 'Edit Anchor Page',
        noindex: true,
        adminAccess: true
      }
    },

    // Anchor Pages
    {
      path: '/anchor-page/:uuid',
      name: 'AnchorPage',
      component: AnchorPage,
      props(route) {
        return {
          uuid: route.params.uuid,
          breadcrumbSubject: route.query.browse_subject,
          breadcrumbDomain: route.query.browse_domain,
          draft: route.query.draft === 'true'
        }
      },
      meta: {
        title: 'Anchor Page',
        requiresAuth: true,
        noindex: true
      }
    },
    {
      path: '/library/anchor-page/:uuid',
      name: 'SavedAnchorPage',
      component: SavedAnchorPage,
      props: true,
      meta: {
        title: 'Saved Anchor Page',
        requiresAuth: true,
        // requiresReloginCheck: true,
        noindex: true,
        fetchLibraryOnEnter: true,
      }
    },
    {
      path: '/share/anchor-page/:uuid',
      name: 'SharedAnchorPage',
      component: SharedAnchorPage,
      props: true,
      meta: {
        title: 'Shared Anchor Page',
        noindex: true
      }
    },
    {
      path: '/library/anchor-page/share/:uuid',
      name: 'SharedAnchorPageDeprecatedUrl',
      component: SharedAnchorPage,
      props: true,
      meta: {
        title: 'Shared Anchor Page',
        noindex: true
      }
    },

    // Goal Content Pages
    {
      path: '/goal/:slug',
      name: 'GoalContentPage',
      component: GoalContentPage,
      props(route) {
        return {
          identifierAttribute: 'slug',
          identifier: route.params.slug,
          expandedLevel: route.query.expanded_level,
          breadcrumbSubject: route.query.browse_subject,
          breadcrumbDomain: route.query.browse_domain
        }
      },
      meta: {
        title: 'Instructional Content Page',
        requiresAuth: true,
        noindex: true
      }
    },
    {
      path: '/library/goal/:uuid',
      name: 'SavedGoalContentPage',
      component: SavedGoalContentPage,
      props: true,
      meta: {
        title: 'Saved Goal Page',
        requiresAuth: true,
        requiresReloginCheck: true,
        noindex: true,
        fetchLibraryOnEnter: true,
      }
    },
    {
      path: '/share/goal/:uuid',
      name: 'SharedGoalContentPage',
      component: SharedGoalContentPage,
      props: true,
      meta: {
        title: 'Shared Goal Page',
        noindex: true
      }
    },

    // Present Levels
    {
      path: '/presentlevels',
      component: PresentLevels,
      props: true,
      meta: {
        title: 'Present Levels',
        requiresAuth: true,
        noindex: true,
        fetchLibraryOnEnter: true,
      },
      children: [
        {
          path: 'results/:uuid/:subject',
          name: 'PresentlevelsSubjectResults',
          component: PresentlevelsResults,
          props: true,
          meta: {
            title: 'Personalized Browse Present Levels',
            requiresAuth: true,
            noindex: true
          }
        },
        {
          path: 'results/:uuid',
          name: 'PresentlevelsResults',
          component: PresentlevelsResults,
          props: true,
          meta: {
            title: 'Personalized Browse Present Levels',
            requiresAuth: true,
            noindex: true
          }
        },
        {
          path: 'browse/:subject',
          name: 'PresentlevelsBrowse',
          component: PresentlevelsResults,
          props: true,
          meta: {
            title: 'Browse Present Levels',
            requiresAuth: true,
            noindex: true
          }
        },
        {
          path: 'conclusion/:uuid',
          component: PresentlevelsConclusion,
          props: true,
          meta: {
            title: 'Present Levels Conclusion',
            requiresAuth: true,
            noindex: true
          },
          children: [
            {
              path: 'assessments',
              name: 'PresentlevelsConclusionAssessments',
              component: PresentLevelsConclusionAssessments,
              props: true,
              meta: {
                title: 'Present Levels Conclusion - Assessments',
                requiresAuth: true,
                noindex: true
              }
            },
            {
              path: 'goals-strategies',
              name: 'PresentlevelsConclusionGoalsStrategies',
              component: PresentlevelsConclusionGoalsStrategies,
              props: true,
              meta: {
                title: 'Present Levels Conclusion - Goals & Strategies',
                requiresAuth: true,
                noindex: true
              }
            },
            {
              path: '',
              name: 'PresentlevelsConclusion',
              component: PresentlevelsConclusionStatement,
              props: true,
              meta: {
                title: 'Present Levels Conclusion',
                requiresAuth: true,
                noindex: true
              }
            },
          ]
        },
        {
          path: ':uuid',
          name: 'PresentLevelsExistingWizard',
          props: true,
          component: PresentlevelsWizardFilters,
          meta: {
            title: 'Present Levels Wizard',
            requiresAuth: true,
            noindex: true
          }
        },
        {
          path: '/',
          name: 'PresentLevelsNewWizard',
          props: { uuid: null },
          component: PresentlevelsWizardFilters,
          meta: {
            title: 'Present Levels Wizard',
            requiresAuth: true,
            noindex: true
          }
        }
      ]
    },
    {
      path: '/share/presentlevels/:uuid',
      name: 'SharedPresentLevelsPage',
      component: SharedPresentLevelsPage,
      props: true,
      meta: {
        title: 'Shared Present Levels Page',
        noindex: true
      }
    },

    // Impact of Disability
    {
      name: 'ImpactOfDisability',
      component: ImpactOfDisability,
      path: '/impact-of-disability',
      meta: {
        title: 'Impact of Disability Statements',
        requiresAuth: true,
        noindex: true,
      },
      props: route => {
        return {
          query: route.query
        }
      }
    },

    // Strategy Detail Pages
    {
      path: '/strategy/:slugOrUuid',
      name: 'StrategyDetailPage',
      component: StrategyDetailPage,
      props(route) {
        return {
          slugOrUuid: route.params.slugOrUuid,
          libraryGoalUuid: route.query.lg
        }
      },
      meta: {
        title: 'UDL Strategies',
        requiresAuth: true,
        noindex: true
      }
    },
    {
      path: '/library/strategy/:uuid',
      name: 'SavedStrategyPage',
      component: SavedStrategyPage,
      props(route) {
        return {
          uuid: route.params.uuid
        }
      },
      meta: {
        requiresAuth: true,
        requiresReloginCheck: true,
        noindex: true,
        fetchLibraryOnEnter: true,
      }
    },
    {
      path: '/share/strategy/:uuid',
      name: 'SharedStrategyDetailPage',
      component: SharedStrategyDetailPage,
      props(route) {
        return {
          uuid: route.params.uuid
        }
      },
      meta: {
        title: 'UDL Strategies',
        noindex: true
      }
    },

    // Library Favorites
    {
      path: '/favorites',
      name: 'Favorites',
      component: FavoritesPage,
      meta: {
        title: 'Favorites',
        requiresAuth: true,
        noindex: true
      }
    },

    // Browse Pages
    {
      path: '/browse',
      name: 'BrowseGoalsPage',
      component: BrowseGoalsPage,
      meta: {
        requiresAuth: true,
        noindex: true
      },
      props: route => {
        return {
          query: route.query
        }
      }
    },
    {
      path: '/wizard',
      component: BrowseGoalsWizard,
      meta: {
        title: 'Personalized Learning Goal Wizard'
      },
      children: [
        {
          path: '',
          name: 'BrowseGoalsWizardModal',
          component: BrowseGoalsWizardModal,
          props: route => {
            return {
              subject: route.query.subject,
              category: route.query.category,
              grade: route.query.grade,
              instructionalLevel: route.query.instructionalLevel
            }
          },
          meta: {
            title: 'Personalized Learning Goal Wizard',
            requiresAuth: true,
            noindex: true
          }
        }
      ]
    },
    {
      path: '/strategies',
      component: StrategyIndexPage,
      name: 'StrategyIndex',
      meta: {
        title: 'UDL Strategies',
        requiresAuth: true,
        noindex: true
      }
    },
    {
      path: '/strategies/wizard',
      component: StrategyWizard,
      name: 'StrategyWizard',
      meta: {
        title: 'UDL Strategy Wizard',
        requiresAuth: true,
        noindex: true
      },
      props: route => {
        return {
          subject: route.query.subject,
          barrier: route.query.barrier,
          grades: route.query.grades && route.query.grades.split(','),
          setting: route.query.setting,
          teachingType: route.query.teachingType
        }
      }
    },
    {
      path: '/browse/strategies',
      name: 'BrowseStrategiesPage',
      component: BrowseStrategiesPage,
      meta: {
        title: 'Browse UDL Strategies',
        requiresAuth: true,
        noindex: true
      },
      props: route => {
        return {
          subject: route.query.subject,
          barrier: route.query.barrier,
          grades: route.query.grades && route.query.grades.split(','),
          setting: route.query.setting,
          teachingType: route.query.teachingType,
          query: route.query.query
        }
      }
    },

    // Curated Collections
    {
      path: '/collections/:id',
      name: 'CuratedCollection',
      component: CollectionPage,
      props: true,
      meta: {
        title: 'Curated Collection',
        requiresAuth: true,
        noindex: true
      }
    },

    // Miscellaneous
    {
      path: '/goal-index',
      name: 'GoalIndexPage',
      component: GoalIndexPage,
      meta: {
        title: 'Learning Goal Index',
        requiresAuth: true,
        noindex: true
      }
    },
    {
      path: '/internal-search',
      name: 'Search',
      component: SearchPage,
      meta: {
        title: 'Goalbook Toolkit Search',
        requiresAuth: true,
        noindex: true
      }
    },
    {
      path: '/browse/assessments',
      name: 'BrowseAssessments',
      component: BrowseAssessments,
      meta: {
        title: 'Browse Assessments',
        requiresAuth: true,
        noindex: true
      }
    },
    {
      path: '/wizard/assessments',
      name: 'AssessmentWizard',
      component: AssessmentWizard,
      meta: {
        title: 'Assessment Wizard',
        requiresAuth: true,
        noindex: true
      },
      beforeEnter: (to, from, next) => {
        if (store.getters['visibility/assessmentWizardVisibility']) {
          next()
        } else {
          next('/')
        }
      }
    },
    {
      path: '/browse/presentlevels',
      name: 'BrowsePresentLevelsPage',
      component: BrowsePresentLevelsPage,
      meta: {
        title: 'Browse Present Levels',
        requiresAuth: true,
      },
      props: route => {
        return {
          query: route.query
        }
      }
    }
  ]
})

import { authRouteGuard, betaRouteGuard, reloginRouteGuard } from './auth_guards'

router.beforeEach(authRouteGuard)
router.beforeEach(reloginRouteGuard(router))
router.beforeEach(betaRouteGuard)

const fetchLibraryData = () => {
  store.dispatch('library/fetchStudents', store.state.user.user.uuid)
  store.dispatch('library/fetchRecentStudents', { userId: store.state.user.user.uuid })
}

router.afterEach((to, from) => {
  // update page title if specified
  setTitle(to.meta.title)

  // update currentUrl
  store.dispatch('updateCurrentUrl', `${urlHelpers.originAndBase}${to.fullPath.slice(1)}`) // omit the leading '/' from fullPath

  // set noindex meta tag if routes shouldn't be crawled
  if (to.matched.some(record => record.meta.noindex)) {
    setOrAppendNoIndexMetaTag()
  }

  const shouldFetchLibraryData = to.matched.some(r => r.meta.fetchLibraryOnEnter)

  if (shouldFetchLibraryData) {
    if (store.getters['user/isAuthenticated']) {
      fetchLibraryData()
    } else {
      store.commit('user/pushOnetimeCallback', fetchLibraryData)
    }
  }

})

export default router
